'use strict';

import { Entity } from '../Entity';
import { GlobProviderTypeCollection } from '../../Collections/Glob/GlobProviderTypeCollection';

export class GlobProviderType extends Entity {
  protected id;
  protected type;
  protected taxonomy;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.type = data.type;
    this.taxonomy = data.taxonomy;
  }

  public getId() {
    return this.id;
  }

  public getType() {
    return this.type;
  }

  public getTaxonomy() {
    return this.taxonomy;
  }
}
